import { Fragment } from "react";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeaderTwo from "../../component/layout/pageheader-2";
import Author from "../../component/sidebar/author";
import Comment from "../../component/sidebar/comment";
import CourseSideCetagory from "../../component/sidebar/course-cetagory";
import CourseSideDetail from "../../component/sidebar/course-detail";
import Respond from "../../component/sidebar/respond";
import Classical from "../../component/layout/Sing/classical";


const ClassicalSingSingle = () => {

    // -------- Tutors for Indian Classical Vocal Category --------
    const classicalTutors = [
        {
            name: "Vishnu Priya",
            expertise: "Hindustani Classical Vocalist",
            experience: "10 Years Experience",
        },
        {
            name: "Smt. Anjali Sharma",
            expertise: "Carnatic & Hindustani Training",
            experience: "8 Years Experience",
        },
        {
            name: "Pandit Ravi Kumar",
            expertise: "Voice Modulation & Raaga Mastery",
            experience: "12 Years Experience",
        },
    ];

    return (
        <Fragment>
            <Header />
            <Classical title="Indian Classical Singing Course" />

            <div className="course-single-section padding-tb section-bg" style={{ backgroundColor: "#FFF8E1" }}>
                <div className="container">
                    <div className="row justify-content-center">

                        {/* LEFT CONTENT */}
                        <div className="col-lg-8">
                            <div className="main-part">

                                {/* Course Overview */}
                                <div className="course-item">
                                    <div className="course-inner">
                                        <div className="course-content">
                                            <h3>Course Overview</h3>
                                            <p>Learn Raagas, Swaras, Alankaras, and traditional Indian vocal techniques.</p>
                                            <h4>What You'll Learn:</h4>
                                            <ul className="lab-ul" style={{ color: "black" }}>
                                                <li>Understanding Swaras</li>
                                                <li>Basic Raaga Structures</li>
                                                <li>Voice Modulation</li>
                                                <li>Alankaras Practice</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* ---------- Course Video Section ---------- */}
                                <div className="course-video" style={{ marginTop: "40px" }}>
                                    <div className="course-video-title">
                                        <h4>Course Content</h4>
                                    </div>

                                    <div className="course-video-content">
                                        <div className="accordion" id="ClassicalSingAcc">
                                            <div className="accordion-item">
                                                <div className="accordion-header" id="cs01">
                                                    <button className="d-flex justify-content-between" data-bs-toggle="collapse" data-bs-target="#videolist1" aria-expanded="true" aria-controls="videolist1">
                                                        <span>1. Introduction & Raaga Basics</span>
                                                        <span>5 Lessons</span>
                                                    </button>
                                                </div>

                                                <div id="videolist1" className="accordion-collapse collapse show" aria-labelledby="cs01" data-bs-parent="#ClassicalSingAcc">
                                                    <ul className="lab-ul video-item-list">
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.1 Welcome & Course Introduction – 03:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.2 Understanding Swaras – 04:30 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.3 Basic Raaga Structures – 05:20 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.4 Alankaras & Voice Modulation – 06:10 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                        <li className="d-flex flex-wrap justify-content-between" style={{ color: "black" }}>
                                                            <div className="video-item-title">1.5 Daily Practice Routine – 07:00 minutes</div>
                                                            <div className="video-item-icon">
                                                                <a href="https://www.youtube-nocookie.com/embed/jP649ZHA8Tg" className="popup" target="_blank">
                                                                    <i className="icofont-play-alt-2"></i>
                                                                </a>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* ---------- End Course Video Section ---------- */}

                                {/* ---------- Tutors Section ---------- */}
                                <div style={{ marginTop: "40px", padding: "20px", background: "#FFFFFF", borderRadius: "10px" }}>
                                    <h3 style={{ marginBottom: "20px" }}>Classical Singing Tutors</h3>

                                    {classicalTutors.map((tutor, index) => (
                                        <div key={index} style={{ padding: "15px", borderBottom: "1px solid #ddd" }}>
                                            <h5 style={{ margin: 0 }}>{tutor.name}</h5>
                                            <p style={{ margin: "5px 0" }}>{tutor.expertise}</p>
                                            <small style={{ color: "#666" }}>{tutor.experience}</small>
                                        </div>
                                    ))}
                                </div>
                                {/* ---------- End Tutors Section ---------- */}

                                {/* Default Components */}
                                <Author />
                                <Comment />
                                <Respond />
                            </div>
                        </div>

                        {/* RIGHT SIDEBAR */}
                        <div className="col-lg-4">
                            <div className="sidebar-part">
                                <CourseSideDetail />
                                <CourseSideCetagory />
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
};

export default ClassicalSingSingle;
